import { useCallback, useEffect } from 'react';
import { makeDebug } from '../../utils/makeDebug';
import { isCurrentUserGuest } from '../auth/utils';
import { isDebugEnabled } from '../debugging';
import { logout } from './sessionTracker';

const debug = makeDebug('guest-checkout', isDebugEnabled('guestCheckout'));

export const useClearGuestUser = () => {
  return useCallback(async () => {
    try {
      const isGuest = await isCurrentUserGuest();
      if (isGuest) {
        debug('logging out guest user account... ');
        await logout();
        debug('guest user logged out and state cleared');
      }
    } catch (e) {
      console.error('Error clear guest user: ', e);
    }
  }, []);
};

export const useClearGuestUserOnUnmounted = () => {
  const clearGuestUser = useClearGuestUser();
  useEffect(
    () => () => {
      debug('clear guest user on unmounted... ');
      void clearGuestUser();
    },
    [clearGuestUser],
  );
};
